import { Component, HostListener, ViewChild, OnInit, OnDestroy, inject } from '@angular/core';
import {CommonModule} from '@angular/common';
import {LanguageService} from "../../shared/services/language.service";
import {LayoutService} from "../../shared/services/layout.service";
import {FormBuilder, FormGroup} from '@angular/forms';
import {ApiService} from "../../shared/services/api.service";
import {IconBadgeComponent} from "../../shared/elements/icon-badge/icon-badge.component";
import {TranslatePipe} from "../../shared/pipes/translate.pipe";
import {HeadlineComponent} from "../../shared/elements/headline/headline.component";
import {ContentComponent} from "../../shared/elements/content/content.component";
import {FormButtonComponent} from "../../shared/elements/form-button/form-button.component";
import {FormDropdownComponent} from "../../shared/elements/form-dropdown/form-dropdown.component";
import { TYPE } from '../../shared/types/types';
import {DialogService} from "../../shared/services/dialog.service";
import {DialogComponent, DialogModule} from "@syncfusion/ej2-angular-popups";
import {TooltipComponent} from "../../shared/elements/tooltip/tooltip.component";
import {FormLabelComponent} from "../../shared/elements/form-label/form-label.component";
import { MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { CheckBoxSelectionService} from '@syncfusion/ej2-angular-dropdowns';
import { ProgressBarModule, ProgressAnnotationService } from '@syncfusion/ej2-angular-progressbar';
import { ITextRenderEventArgs } from '@syncfusion/ej2-progressbar';
import {AccordionModule} from "@syncfusion/ej2-angular-navigations";
import {FormCheckboxComponent} from "../../shared/elements/form-checkbox/form-checkbox.component";
import { AccumulationChartModule, IAccLoadedEventArgs } from '@syncfusion/ej2-angular-charts'
import { PieSeriesService, AccumulationLegendService, AccumulationTooltipService, AccumulationAnnotationService,AccumulationDataLabelService,ChartModule} from '@syncfusion/ej2-angular-charts'
import { GridModule, PageService, SortService, FilterService } from '@syncfusion/ej2-angular-grids';
import { ColumnSeriesService, DateTimeService, CategoryService, ZoomService,LegendService, DataLabelService } from '@syncfusion/ej2-angular-charts';
import { SliderModule, SliderTickEventArgs, RatingModule} from '@syncfusion/ej2-angular-inputs';
import {FormInputComponent} from "../../shared/elements/form-input/form-input.component";
import {NgSrcImageErrorDirective} from '../../shared/directives/ng-src-image-error.directive';

declare let bootstrap: any;

@Component({
    selector: 'app-feedback-stats-sd',
    imports: [
        CommonModule,
        TranslatePipe,
        IconBadgeComponent,
        HeadlineComponent,
        ContentComponent,
        FormButtonComponent,
        FormDropdownComponent,
        DialogModule,
        TooltipComponent,
        FormLabelComponent,
        MultiSelectModule,
        ProgressBarModule,
        AccordionModule,
        FormCheckboxComponent,
        AccumulationChartModule,
        GridModule,
        ChartModule,
        SliderModule,
        RatingModule,
        FormInputComponent,
        NgSrcImageErrorDirective
    ],
    templateUrl: './feedback-stats-sd.component.html',
    styleUrl: './feedback-stats-sd.component.scss',
    providers: [CheckBoxSelectionService,
        ProgressAnnotationService,
        PieSeriesService,
        AccumulationLegendService,
        AccumulationTooltipService,
        AccumulationDataLabelService,
        AccumulationAnnotationService, PageService,
        SortService,
        FilterService,
        ColumnSeriesService,
        CategoryService,
        LegendService,
        DataLabelService,
        ZoomService,
        LegendService
    ]
})


export class FeedbackStatsSdComponent implements OnInit, OnDestroy {
  layoutService = inject(LayoutService);
  private formBuilder = inject(FormBuilder);
  private languageService = inject(LanguageService);
  private apiService = inject(ApiService);
  dialogService = inject(DialogService);

  @ViewChild('showPrevInstanceFilter') showPrevInstanceFilter: DialogComponent | any;
  @ViewChild('showCombineInstancesFilter') showCombineInstancesFilter: DialogComponent | any;
  @ViewChild('showSuccessUsersDialog') showSuccessUsersDialog: DialogComponent | any;

  ngOnInit() {
    this.setResponsiveSize();
  }

  ngOnDestroy() {
    clearTimeout(this.resizeTimeout);
  }

  public feedbackStatsForm: FormGroup = this.formBuilder.group({
    feedbackStatsSummaryByTime: ['latest'],
    feedbackStatsSummaryByUsersOrGroups: ['all'],
    feedbackStatsParticipantByTime: ['latest'],
    feedbackListOfPrevInstance: [''],
    show_chart: [true],
    show_description: [true],
    slider_unit_text: ['$'],
    slider_unit_onleftside: [true],
    search_users_string: ['']
  });

  feedbackStatsSummaryTimeFilter: any[] = [
    {id: 'latest', name: this.languageService.getTranslationByKey('FEEDBACKFILTERSTATSLATESTSUMMARYMENU')},
    {id: 'combined-instances', name: this.languageService.getTranslationByKey('FEEDBACKFILTERSTATSCOMBINEDINSTANCESMENU')},
  ];

  feedbackStatsSummaryUserGroupFilter: any[] = [
    {id: 'all', name: this.languageService.getTranslationByKey('FEEDBACKFILTERSTATSBYALLMENU')},
    {id: 'by-user', name: this.languageService.getTranslationByKey('FEEDBACKFILTERSTATSBYUSERSMENU')},
    {id: 'by-group', name: this.languageService.getTranslationByKey('FEEDBACKFILTERSTATSBYGROUPSMENU')}
  ];

  feedbackStatsParticpantsTimeFilter: any[] = [
    {id: 'latest', name: this.languageService.getTranslationByKey('FEEDBACKFILTERSTATSLATESTSUMMARYMENU')},
    {id: 'prev-instance', name: this.languageService.getTranslationByKey('FEEDBACKFILTERSTATSPREVINSTANCEMENU')},
  ];

  feedbackStatsParticpantsUserFilter: any[] = [
    {id: 'by-user', name: this.languageService.getTranslationByKey('FEEDBACKFILTERSTATSBYUSERMENU')}
  ];

  feedbackPrevInstances: any[] = [
    {id: '2025-03-15', name: '15 March 2025'},
    {id: '2025-03-22', name: '22 March 2025'},
    {id: '2025-04-02', name: 'April 2025'},
    {id: '2024-01-01', name: '2024'}
  ];

  loadList1(module: string | number | TYPE.FieldSettingsModelWithId = ''){
    if(module == 'prev-instance')
    {
      this.showPrevInstanceFilter!.show();
    }else if(module == 'combined-instances'){
      this.showCombineInstancesFilter!.show();
    }
  }

  loadList2(module: string | number | TYPE.FieldSettingsModelWithId = ''){
    if(module == 'by-group'){
      alert('Popup with multiple Groups selection');
    }else if(module == 'by-users'){
      alert('Popup with multiple users selection')
    }
  }

  loadList3(module: string | number | TYPE.FieldSettingsModelWithId = ''){
    if(module == 'by-user'){
      alert('Popup with single users selection like in News filter')
    }
  }

  onOpenDialog = (event: any, id: string): void => {
    event.preventDefault();
    if(id == 'show-successusers')
    {
      this.showSuccessUsersDialog.show();
    }
  }

  closeDialog(id = ""): void {
  }

  clearFilter(){

  }

  /*Multiselect Dropdown for filter*/
  // set the type of mode for checkbox to visualized the checkbox added in li element.
  public mode = 'CheckBox';
  // set the select all text to MultiSelect checkbox label.
  public selectAllText= 'Select All';
  public unselectAllText= 'Unselect All';

  public sportsData: object[] =  [
    { id: '1', instance: '15 March 2025' },
    { id: '2', instance: '22 March 2025' },
    { id: '3', instance: '29 March 2025' },
    { id: '4', instance: '15 April 2025' },
    { id: '5', instance: '22 April 2025' },
    { id: '6', instance: 'Bla' },
    { id: '7', instance: 'Bla' },
    { id: '8', instance: 'Bla' },
    { id: '9', instance: 'Bla' },
    { id: '10', instance: 'Bla' },
    { id: '11', instance: 'Bla' },
    { id: '12', instance: 'Bla' },
    { id: '13', instance: 'Bla' },
    { id: '14', instance: 'Bla' },
    { id: '15', instance: 'Bla' },
    { id: '16', instance: 'Bla' },

  ];
  // maps the appropriate column to fields property
  public fields: object = { text: 'instance', value: 'id' };
  // set placeholder to MultiSelect input element
  public placeholder = 'Select Feedback';

  /* Circular Progress */
  minValue =0;
  maxValue =600;
  currentValue = 565;

  textWhenTwoValues(args: ITextRenderEventArgs): void {
    args.text = `${this.currentValue}/${this.maxValue}`;
  }

  textWhenNoPercentage(args: ITextRenderEventArgs): void {
    args.text = `${this.currentValue}`;
  }

  /*Chart Section */
  chartWidth = "100%";
  chartHeight = "100%";

  legendSettings = {
    visible: false,
    width: '350', height: '100', border: { width: 0, color: 'var(--our-text-color)'},
    position:'Bottom' ,alignment:'Center'
  };

  center = {x: '50%', y: '50%'};


  resizeTimeout: any;

  @HostListener('window:resize')
  onWindowResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.setResponsiveSize();
    }, 200);
  }

  setResponsiveSize() {
    const screenWidth = window.innerWidth;

    if (screenWidth < 400) {
      this.chartHeight = '200px';
    } else if (screenWidth < 600) {
      this.chartHeight = '250px';
    } else {
      this.chartHeight = '350px';
    }
  }

  datalabel = {
    visible: true,
    //name: 'y',
    position: 'Outside',
    template: '<div class="accumulation-chart-label">${point.y}%</div>',

  };

  public centerLabelData: object= [
    { x: 'A1', y: 61.3},
    { x: 'A2', y: 24.6},
    { x: 'A3', y: 5.0},
    { x: 'A4', y: 2.7},
    { x: 'A5', y: 2.6},
    { x: 'A6', y: 3.6}
  ];

  centerLabel = {
    text : 'Q1',
    hoverTextFormat: '${point.x} : ${point.y}%',
    textStyle:{
        fontWeight: 'bold',
        size: 'var(--our-font-size-small)',
        color: 'var(--our-text-color)',
        fontFamily: 'var(--our-font-family)'
    }
  }

  //Get the generated chart colors for each centerLabelData.x
  public segmentColors: Record<string, string> = {};
  onPointRender(args: any): void {
    const label = args.point.x;
    const color = args.fill;
    this.segmentColors[label] = color;

    //console.log(this.segmentColors);
  }

  //grid for dates
  public dateStatsData: any[] = [
    { date: '2024-03-15', me: '12%', count: 12, percentage: '24%' },
    { date: '2024-03-16', me: '12%', count: 9, percentage: '18%' },
    { date: '2024-03-17', me: '12%', count: 8, percentage: '16%' },
    { date: '2024-03-18', me: '12%', count: 6, percentage: '12%' },
    { date: '2024-03-19', me: '12%', count: 5, percentage: '10%' },
    { date: '2024-03-20', me: '12%', count: 4, percentage: '8%' },
    { date: '2024-03-21', me: '12%', count: 3, percentage: '6%' },
    { date: '2024-03-22', me: '12%', count: 2, percentage: '4%' },
    { date: '2024-04-15', me: '12%', count: 12, percentage: '24%' },
    { date: '2024-04-16', me: '12%', count: 9, percentage: '18%' },
    { date: '2024-04-17', me: '12%', count: 8, percentage: '16%' },
    { date: '2024-04-18', me: '12%', count: 6, percentage: '12%' },
    { date: '2024-04-19', me: '12%', count: 5, percentage: '10%' },
    { date: '2024-04-20', me: '12%', count: 4, percentage: '8%' },
    { date: '2024-04-21', me: '12%', count: 3, percentage: '6%' },
    { date: '2024-04-22', me: '12%', count: 2, percentage: '4%' },
    { date: '2024-05-15', me: '12%', count: 12, percentage: '24%' },
    { date: '2024-05-16', me: '12%', count: 9, percentage: '18%' },
    { date: '2024-05-17', me: '12%', count: 8, percentage: '16%' },
    { date: '2024-05-18', me: '12%', count: 6, percentage: '12%' },
    { date: '2024-05-19', me: '12%', count: 5, percentage: '10%' },
    { date: '2024-05-20', me: '12%', count: 4, percentage: '8%' },
    { date: '2024-05-21', me: '12%', count: 3, percentage: '6%' },
    { date: '2024-05-22', me: '12%', count: 2, percentage: '4%' },

  ];

  /* Chart for Dates */
  public primaryXAxis = {
    valueType: 'Category',
    title: 'Date',
    labelIntersectAction: 'Rotate45',
    titleStyle: {
      size: 'var(--our-font-size-default)', color: 'var(--our-title-color)',
      fontFamily : 'var(--our-font-family)', fontWeight : 'bold'
    },
    labelStyle: {
      size: '9px', color: 'var(--our-text-color)',
      fontFamily : 'var(--our-font-family)'
    }
  };

  public primaryYAxis = {
    title: 'Users',
    labelFormat: '{value}',
    titleStyle: {
      size: 'var(--our-font-size-default)', color: 'var(--our-title-color)',
      fontFamily : 'var(--our-font-family)', fontWeight : 'bold'
    },
    labelStyle: {
      size: '9px', color: 'var(--our-text-color)',
      fontFamily : 'var(--our-font-family)'
    }
  };

  labelMarker = { dataLabel: { visible: true,
    template: '<div class="accumulation-chart-label">${point.y}</div>' }
  };

  zoom = {
    enableMouseWheelZooming: true,
    enablePinchZooming: true,
    enableSelectionZooming: true,
    showToolbar: true,
    mode: 'X'
  };

  /*Slider*/
  labelAtStart = false;
  initialValue = 1;
  handleSteps = 0.1;
  minInterval = 0;
  maxInterval = 2
  ticks: object = { placement: 'After', largeStep: 0.2, smallStep: 0.1, showSmallTicks: true };
  tooltip={ placement: 'Before', isVisible: true};

  renderingTicksHandler(args: SliderTickEventArgs | any): void {
      if(!this.feedbackStatsForm.get('slider_unit_text')?.value) return;
      if(this.feedbackStatsForm.get('slider_unit_onleftside')?.value)
      {
        args.text =  this.feedbackStatsForm.get('slider_unit_text')?.value + (Number(args.value) + 1).toString();
      }else{
        args.text =  Number(args.value) +  this.feedbackStatsForm.get('slider_unit_text')?.value;
      }
  }

  /* Switch tabs */
  switchToTab(){
    alert('Show the participants tab with the selected user stats');
  }

  showMyStats = false;
  showMyStatsToggle(){
    this.showMyStats = !this.showMyStats;
  }
}
